import { apiUrl, apiUrlV2 } from "../constants/apiUrl"
import sortUnitsByNapIssues from "../utilities/sortUnitsByNapIssues"
import createSearchParams from "../utilities/createSearchParams"
import rollbarLogger from "../utilities/rollbarLogger"

const initialState = {
  units: [],
  unit: undefined,
  comingDueUnits: [],
  soldUnits: [],
  amountDueOn: {},
  isFetchingAmountDue: false,
  unitsFetching: false,
  unitFetching: false,
  dashboardUnitId: null,
  amUnitsTableParams: '',
  dealerUnitsSearchBarValue: '',
  dealerUnitsPaginationData: {},
  selectedDealerUnitsScopeLabel: null,
  dealerUnitsPage: 1
}

const createDealerUnitsSlice = (set, get) => ({
  ...initialState,
  setDealerUnitsSearchBarValue: (params) => {
    set((state) => ({dealerUnitsSearchBarValue: params}))
  },
  setAmUnitsTableParams: (params = {}) => {
    set((state) => ({
      amUnitsTableParams: {
        'filter[scope]': 'current',
        ...params,
      }
    }))
  },

  setUnitsFetching: (boolean) => {
    set((state) => ({ unitsFetching: boolean }))
  },
  setSelectedDealerUnitsScopeLabel: (params) => {
    set((state) => ({selectedDealerUnitsScopeLabel: params}))
  },
  setDealerUnitsPage: (page) => {
    set((state) => ({dealerUnitsPage: page}))
  },
  fetchUnitsAsAm: async (dealerId, params = {}) => {
    set((state) => ({ unitsFetching: true }))

    const searchParams = {
      'filter[scope]': 'current',
      ...params,
    }

    try {
      const response = await fetch(
        `${apiUrlV2}/dealers/${dealerId}/units?page=${get().dealerUnitsPage}&${createSearchParams(searchParams)}`,
        { headers: get().requestHeaders }
      )
      const data = await response.json()

      if (get().user) {
        const units = data.data
        if (units?.some((u) => u.attributes['nap-issues'].length > 0)) {
          sortUnitsByNapIssues(units)
        }
        set((state) => ({
          units: units,
          dealerUnitsPaginationData: {
            dealerUnitsResultsCount: response.headers.get('x-total'),
            lastPage: response.headers.get('x-last-page'),
            totalPages: response.headers.get('x-total-pages'),
            currentPage: Number(response.headers.get('x-page')) - 1
          }
        }))
      }
    } catch (err) {
      get().logError('There was an error fetching units as an AM.', err)
    } finally {
      set(() => ({ unitsFetching: false }))
    }
  },
  resetUnitsAsAmSlice: () => set(initialState)
  })

  export default createDealerUnitsSlice
